export const courierAbbr = (courier) => {
  if (!courier) return null;

  var abbr = "";
  var lowerCourier = courier.toLowerCase();

  if (lowerCourier.indexOf("fastway") >= 0) {
    abbr = "FW";
  } else if (lowerCourier.indexOf("startrack") >= 0) {
    abbr = "ST";
  } else if (lowerCourier.indexOf("direct") >= 0) {
    abbr = "DF";
  } else if (lowerCourier.indexOf("australia post") >= 0) {
    abbr = "AP";
  } else if (lowerCourier.indexOf("australia post letter") >= 0) {
    abbr = "LE";
  } else if (lowerCourier.indexOf("dhl") >= 0) {
    abbr = "DHL";
  } else if (lowerCourier.indexOf("toll express") >= 0) {
    abbr = "TE";
  } else if (lowerCourier.indexOf("mainfreight") >= 0) {
    abbr = "MF";
  } else if (lowerCourier.indexOf("border express") >= 0) {
    abbr = "BE";
  }

  return abbr;
};

export const courierLink = (courier, courierTracking) => {
  if (!courier) return null;
  let abbr = courierAbbr(courier);
  let link = "";

  if (abbr == "FW") {
    link = "http://www.fastway.com.au/courier-services/track-your-parcel?l=" + courierTracking;
  } else if (abbr == "ST") {
    link = "https://www.startrack.com.au/track-trace/?id=" + courierTracking;
  } else if (abbr == "DF") {
    link = "https://www.directfreight.com.au/ConsignmentStatus.aspx?lookuptype=0&consignment_no=" + courierTracking;
  } else if (abbr == "AP") {
    link = "http://www.auspost.com.au/track/track.html?id=" + courierTracking;
  } else if (abbr == "LE") {
    link = "http://www.auspost.com.au/track/track.html?id=" + courierTracking;
  } else if (abbr == "DHL") {
    link = "http://www.dhl.com.au/content/au/en/express/tracking.shtml?brand=DHL&AWB=" + courierTracking;
  } else if (abbr == "TE") {
    link = "https://online.toll.com.au/trackandtrace" + courierTracking;
  } else if (abbr == "MF") {
    link = "https://www.mainfreight.com/Track/?" + courierTracking;
  } else if (abbr == "BE") {
    link = "https://www.borderexpress.com.au/tracking/?cn=" + courierTracking;
  }

  return link;
};

export const statusAbbr = (id) => {
  if (id == undefined) return null;
  var abbr = "";
  switch (parseInt(id)) {
    case 1:
      //abbr = 'Pending - Payment Required';
      abbr = "PPR";
      break;

    case 2:
      //abbr = 'Confirmed, Awaiting Shipment';
      abbr = "CAS";
      break;

    case 3:
      //abbr = 'Payment Received. Order Processing';
      abbr = "PROP";
      break;

    case 4:
      //abbr = 'Shipped and Completed';
      abbr = "S&C";
      break;

    case 5:
      //abbr = 'Refunded';
      abbr = "REF";
      break;

    case 6:
      //abbr = 'Decline';
      abbr = "DECL";
      break;

    case 7:
      //abbr = 'Cancelled';
      abbr = "CXL";
      break;

    case 8:
      //abbr = 'Waiting Shipping';
      abbr = "WS";
      break;

    case 9:
      //abbr = 'Backordered';
      abbr = "BO";
      break;

    case 10:
      //abbr = 'In Production';
      abbr = "INPR";
      break;

    default:
      abbr = "Unknown";
  }

  return abbr;
};
